<script>
  /**
   * 複数チェックボックスの選択値を1つの文字列にまとめる UI
   * - hidden input type="text" にカンマ区切りの一つの文字列にしてセットし Submit 出来るようにする
   */
  import CheckboxInput from './CheckboxInput.svelte'

  export let id
  export let name
  export let label
  export let values = []
  export let checked = [] // チェックされた値の配列
  export let isLoading = false
  export let value

  $: {
    value = checked.join()
  }
</script>

<!-- 下記のチェックボックスのデータを Submit してしまわないよう name 属性を設定しない https://qiita.com/oieioi/items/7db723bddd77973ecf25 -->
<CheckboxInput {id} {label} {values} {isLoading} bind:checked />
<!-- 選択メンバーを1つの文字列にまとめてhiddenでSubmitに含める -->
<input type="text" {name} data-testid={`${id}Combined`} {value} hidden />
